(function($) {
  'use strict';

  $(".js-card-media").hover(function() {
    if( $(this).find('video').length ) {
      $(this).find("video")[0].play();
    }
  }, function() {
    if( $(this).find('video').length ) {
      let el = $(this).find("video")[0];
      el.pause();
      // el.currentTime = 0;
    }
  });

})(jQuery);
